import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import { Link } from 'react-router-dom';

// import MainLayout from "../../layouts/MainLayout";

// import Notification from '../../components/utils/Notification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faShare, faSave, faPrint, faDice, faDiceOne, faDiceFour, faDiceFive, faDiceTwo, faDiceThree } from '@fortawesome/free-solid-svg-icons';
import FiveWhysInfoGraphics from './FiveWhysInfoGraphics';
import T5WInfographics1Image from '../../fivewhystemplates/T5WInfographics1.png';
import T5WInfographics2Image from '../../fivewhystemplates/T5WInfographics2.png';
import T5WInfographics3Image from '../../fivewhystemplates/T5WInfographics3.png';
import T5WInfographics4Image from '../../fivewhystemplates/T5WInfographics4.png';
import T5WInfographics5Image from '../../fivewhystemplates/T5WInfographics5.png';
import './BoxAnimation.css';

const Think5WhysDB = () => {
  const authState = useSelector(state => state.authReducer);
  const [records, setRecords] = useState([]);
  const [category, setCategory] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  const [fetchData, { loading }] = useFetch();
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const categories = [
    { label: 'Select Your Area / Category', value: '' },
    { label: 'Children & Family', value: 'Children & Family' },
    { label: 'e-commerce Sector', value: 'e-commerce Sector' },
    { label: 'Educational Institutions', value: 'Educational Institutions' },
    { label: 'Family Business', value: 'Family Business' },
    { label: 'General', value: 'General' },
    { label: 'Government Sector', value: 'Government Sector' },
    { label: 'Healthcare Sector', value: 'Healthcare Sector' },
    { label: 'Human Resource Department', value: 'Human Resource Department' },
    { label: 'IT Sector', value: 'IT Sector' },
    { label: 'Manufacturing Sector', value: 'Manufacturing Sector' },
    { label: 'Social', value: 'Social' },
    { label: 'Students', value: 'Students' },
    { label: 'Transportation and Logistics Sector', value: 'Transportation and Logistics Sector' }
  ];
  const [oneView1, setOneView1] = useState(false);
  const [oneView2, setOneView2] = useState(false);
  const [oneView3, setOneView3] = useState(false);
  const [oneView4, setOneView4] = useState(false);
  const [oneView5, setOneView5] = useState(false);

  const [oneViewFontSize, setOneViewFontSize] = useState(14);

  const fetchRecords = useCallback(async () => {
    try {
      if (!category) {
        setNotificationMessage('Please select a category before searching.');
        return;
      }
      const config = {
        url: "/think5whysdb",
        method: "GET",
        headers: { Authorization: authState.token },
        params: { category }
      };
      // console.log("I am here: ", JSON.stringify(config));
      const data = await fetchData(config, { showSuccessToast: false });
      if (data && data.records) {
        setRecords(data.records);
      } else {
        console.error('No records found in the response:', data);
        setNotificationMessage('No records found for the selected category.');
      }
    } catch (error) {
      console.error('Error during fetching records:', error);
      setNotificationMessage('Failed to fetch records. Please try again later.');
    }
  }, [authState.token, category, fetchData]);

  useEffect(() => {
    if (category) {
      fetchRecords(category);
    }
  }, [category, fetchRecords]);

  const handleSearch = () => {
    if (!category) {
      setNotificationMessage('Please select a category before searching.');
    } else {
      fetchRecords(category);
    }
  };

  const handleView = (recordID) => {
    setSelectedRecordId(prevId => (prevId === recordID ? null : recordID));
  };

  const handleRecordShare = (recordID) => {
    setSelectedRecordId(recordID);
  };

  const handleRecordSave = (recordID) => {
    setSelectedRecordId(recordID);
  };

  const handleRecordPrint = (recordID) => {
    setSelectedRecordId(recordID);
  };

  // const sortedRecords = [...records].sort((a, b) => new Date(b.date) - new Date(a.date));
  const sortedRecords = [...records].sort((a, b) => {
    if (a.concernArea < b.concernArea) {
      return -1;
    }
    if (a.concernArea > b.concernArea) {
      return 1;
    }
    return 0;
  });

  const handleOneView1 = () => {
    setOneView1(prevState => !prevState);
  };

  const handleOneView2 = () => {
    setOneView2(prevState => !prevState);
  };

  const handleOneView3 = () => {
    setOneView3(prevState => !prevState);
  };

  const handleOneView4 = () => {
    setOneView4(prevState => !prevState);
  };

  const handleOneView5 = () => {
    setOneView5(prevState => !prevState);
  };

  return (
    <div className='bg-black [&_p]:text-white'>
      <div className="mx-auto bg-black rounded-md shadow-md">
        <div className="text-left px-4 py-2 mb-2">
          <p className='text-xl lg:text-2xl py-2 text-yellow-200'>5 Whys Analysis Example Database</p>
        </div>
        <div className="min-h-[82vh] border border-gray-600 rounded-md p-4 bg-black">
          <div className="flex justify-between items-center mb-4 gap-4">
            <div className="flex-1">
              <select className="bg-gray-700 text-white border border-gray-600 h-10 rounded-md p-2 w-full" value={category} onChange={(e) => setCategory(e.target.value)}>
                {categories.map((cat, index) => (
                  <option key={index} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <button className="bg-yellow-500 text-white rounded-md p-2 mt-4 w-20 hover:bg-yellow-400" onClick={handleSearch}>
                {loading ? 'Searching...' : 'Search'}
              </button>
              </div>
          </div>
          <div className="border border-gray-600 p-4 bg-black rounded-md">
            {loading ? (
              <Loader />
            ) : (
              <div>
                {records.length === 0 ? (
                  <div className='flex items-center justify-center text-yellow-300'>
                    <span>No record found</span>
                  </div>
                ) : (
                  sortedRecords.map((record) => (
                    <div key={record._id} className='bg-black my-2 p-4 text-gray-300 rounded-md shadow-md'>
                      <div className='flex items-center mb-2'>
                        <span className='font-medium text-yellow-500'>#{record.recordID}</span>
                        <Tooltip text={"View details"} position={"top"}>
                          <span className='ml-auto text-blue-500 cursor-pointer' onClick={() => handleView(record._id)}>
                            <FontAwesomeIcon icon={faEye} />
                          </span>
                        </Tooltip>
                      </div>
                      <div className='text-blue-300'>{record.concernArea}</div>
                      {selectedRecordId === record._id && (
                        <div className='bg-gray-800 text-gray-300 p-4 mt-4 rounded-md'>
                          <h2 className='text-blue-500 mb-2'><strong>Concern Details</strong></h2>
                          <p><strong>Code:</strong> {record.recordID}</p>
                          <div className='my-4'>
                          <Tooltip text={"One-View1"} position={"top"}>
                            <span 
                              className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect'
                              onClick={() => handleOneView1(record._id, 2)}
                            >
                              <FontAwesomeIcon icon={faDiceOne} />
                            </span>
                          </Tooltip>
                            {oneView1 && (
                              <FiveWhysInfoGraphics
                                title={"Root Cause Analysis"}
                                problemCode={record.recordID}
                                category={record.category}
                                subCategory={record.subCategory}
                                concern={record.concernArea}
                                problemStatement={record.problemStatement}
                                why1={record.why1}
                                why2={record.why2}
                                why3={record.why3}
                                why4={record.why4}
                                why5={record.why5}
                                rootCause={record.rootCause}
                                fontSize={16} 
                                lineHeight={20} 
                                lineWidth={100}
                                startXTitle={50} 
                                startYTitle={50} 
                                startXProblemCode={50} 
                                startYProblemCode={60} 
                                startXCategory={50} 
                                startYCategory={90} 
                                startXSubCategory={50} 
                                startYSubCategory={110} 
                                startXConcern={150} 
                                startYConcern={30} 
                                startXProblemStatement={150} 
                                startYProblemStatement={110} 
                                startXWhy1={150} 
                                startYWhy1={200} 
                                startXWhy2={150} 
                                startYWhy2={320} 
                                startXWhy3={150} 
                                startYWhy3={440} 
                                startXWhy4={150} 
                                startYWhy4={550}
                                startXWhy5={150} 
                                startYWhy5={660} 
                                startXRootCause={150} 
                                startYRootCause={780} 
                                imageSrc={T5WInfographics1Image} 
                                viewWidth={500}
                              />
                            )}
                            {/* <Tooltip text={"One-View2"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl' onClick={() => handleOneView2(record._id, 2)}>
                              <FontAwesomeIcon icon={faDiceTwo} />
                            </span>
                            </Tooltip> */}
                            <Tooltip text={"One-View2"} position={"top"}>
                            <span 
                              className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect'
                              onClick={() => handleOneView2(record._id, 2)}
                            >
                              <FontAwesomeIcon icon={faDiceTwo} />
                            </span>
                          </Tooltip>
                            {oneView2 && (
                              <FiveWhysInfoGraphics
                                title={"Root Cause Analysis"}
                                problemCode={record.recordID}
                                category={record.category}
                                subCategory={record.subCategory}
                                concern={record.concernArea}
                                problemStatement={record.problemStatement}
                                why1={record.why1}
                                why2={record.why2}
                                why3={record.why3}
                                why4={record.why4}
                                why5={record.why5}
                                rootCause={record.rootCause}
                                fontSize={oneViewFontSize} 
                                lineHeight={20} 
                                lineWidth={300}

                                startXTitle={10} 
                                startYTitle={50} 
                                startXProblemCode={10} 
                                startYProblemCode={60} 
                                startXCategory={10} 
                                startYCategory={90} 
                                startXSubCategory={10} 
                                startYSubCategory={110} 
                                
                                startXConcern={30} 
                                startYConcern={70} 
                                startXProblemStatement={30} 
                                startYProblemStatement={130} 
                                startXWhy1={30} 
                                startYWhy1={260} 
                                startXWhy2={30} 
                                startYWhy2={370} 
                                startXWhy3={30} 
                                startYWhy3={480} 
                                startXWhy4={30} 
                                startYWhy4={585}
                                startXWhy5={30} 
                                startYWhy5={700} 
                                startXRootCause={30} 
                                startYRootCause={780} 
                                imageSrc={T5WInfographics2Image} 
                                viewWidth={500}
                              />
                            )}
                            <Tooltip text={"One-View3"} position={"top"}>
                              <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' onClick={() => handleOneView3(record._id, 3)}>
                                <FontAwesomeIcon icon={faDiceThree} />
                              </span>
                            </Tooltip>
                            {oneView3 && (
                              <FiveWhysInfoGraphics
                              title={"Root Cause Analysis"}
                                problemCode={record.recordID}
                                category={record.category}
                                subCategory={record.subCategory}
                                concern={record.concernArea}
                                problemStatement={record.problemStatement}
                                why1={record.why1}
                                why2={record.why2}
                                why3={record.why3}
                                why4={record.why4}
                                why5={record.why5}
                                rootCause={record.rootCause}
                                fontSize={24} 
                                lineHeight={30} 
                                lineWidth={500} 
                                startXTitle={30} 
                                startYTitle={60} 
                                startXProblemCode={30} 
                                startYProblemCode={60} 
                                startXCategory={50} 
                                startYCategory={90} 
                                startXSubCategory={50} 
                                startYSubCategory={110} 
                                startXConcern={30} 
                                startYConcern={65} 
                                startXProblemStatement={30} 
                                startYProblemStatement={140} 
                                startXWhy1={30} 
                                startYWhy1={340} 
                                startXWhy2={30} 
                                startYWhy2={510} 
                                startXWhy3={30} 
                                startYWhy3={710} 
                                startXWhy4={30} 
                                startYWhy4={900}
                                startXWhy5={30} 
                                startYWhy5={1080} 
                                startXRootCause={30} 
                                startYRootCause={1240} 
                                imageSrc={T5WInfographics3Image} 
                                viewWidth={800}
                              />
                            )}
                            <Tooltip text={"One-View4"} position={"top"}>
                              <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' onClick={() => handleOneView4(record._id, 4)}>
                                <FontAwesomeIcon icon={faDiceFour} />
                              </span>
                            </Tooltip>
                            {oneView4 && (
                              <FiveWhysInfoGraphics
                                title={"Root Cause Analysis"}
                                problemCode={record.recordID}
                                category={record.category}
                                subCategory={record.subCategory}
                                concern={record.concernArea}
                                problemStatement={record.problemStatement}
                                why1={record.why1}
                                why2={record.why2}
                                why3={record.why3}
                                why4={record.why4}
                                why5={record.why5}
                                rootCause={record.rootCause}
                                fontSize={24} 
                                lineHeight={50} 
                                lineWidth={500} 
                                startXTitle={50} 
                                startYTitle={50} 
                                startXProblemCode={50} 
                                startYProblemCode={70} 
                                startXCategory={50} 
                                startYCategory={90} 
                                startXSubCategory={50} 
                                startYSubCategory={110} 
                                startXConcern={20} 
                                startYConcern={80} 
                                startXProblemStatement={90} 
                                startYProblemStatement={200} 
                                startXWhy1={90} 
                                startYWhy1={350} 
                                startXWhy2={90} 
                                startYWhy2={510} 
                                startXWhy3={90} 
                                startYWhy3={670} 
                                startXWhy4={90} 
                                startYWhy4={820}
                                startXWhy5={90} 
                                startYWhy5={975} 
                                startXRootCause={90} 
                                startYRootCause={1150} 
                                imageSrc={T5WInfographics4Image} 
                                viewWidth={800}
                              />
                            )}
                            <Tooltip text={"One-View5"} position={"top"}>
                              <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl running-border-effect' onClick={() => handleOneView5(record._id, 5)}>
                                <FontAwesomeIcon icon={faDiceFive} />
                              </span>
                            </Tooltip>
                            {oneView5 && (
                              <FiveWhysInfoGraphics
                                title={"Root Cause Analysis"}
                                problemCode={record.recordID}
                                category={record.category}
                                subCategory={record.subCategory}
                                concern={record.concernArea}
                                problemStatement={record.problemStatement}
                                why1={record.why1}
                                why2={record.why2}
                                why3={record.why3}
                                why4={record.why4}
                                why5={record.why5}
                                rootCause={record.rootCause}
                                fontSize={20} 
                                lineHeight={30} 
                                lineWidth={500} 
                                startXTitle={50}
                                startYTitle={50} 
                                startXProblemCode={50} 
                                startYProblemCode={70} 
                                startXCategory={50} 
                                startYCategory={90} 
                                startXSubCategory={50} 
                                startYSubCategory={110} 
                                startXConcern={25} 
                                startYConcern={60} 
                                startXProblemStatement={30} 
                                startYProblemStatement={180} 
                                startXWhy1={170} 
                                startYWhy1={330} 
                                startXWhy2={170} 
                                startYWhy2={470} 
                                startXWhy3={170} 
                                startYWhy3={650} 
                                startXWhy4={170} 
                                startYWhy4={800}
                                startXWhy5={170} 
                                startYWhy5={950} 
                                startXRootCause={30} 
                                startYRootCause={1140} 
                                imageSrc={T5WInfographics5Image} 
                                viewWidth={800}
                              />
                            )}
                          </div>
                          <p><strong>Category:</strong> {record.category}</p>
                          <p><strong>Sub-category:</strong> {record.subCategory}</p>
                          <p><strong>Concern:</strong> {record.concernArea}</p>
                          <p><strong>Problem Statement:</strong> {record.problemStatement}</p>
                          <p><strong>Why1:</strong> {record.why1}</p>
                          <p><strong>Why2:</strong> {record.why2}</p>
                          <p><strong>Why3:</strong> {record.why3}</p>
                          <p><strong>Why4:</strong> {record.why4}</p>
                          <p><strong>Why5:</strong> {record.why5}</p>
                          <p><strong>Root Cause:</strong> {record.rootCause}</p>
                          <p><strong>Reference:</strong> {record.bookReference}</p>
                          <p><strong>Version:</strong> {record.version}</p>
                          <p className='mb-4'><strong>Author:</strong> {record.author}</p>
                          {/* <div className='flex gap-4'>
                            <Tooltip text={"Share"} position={"top"}>
                              <span className='text-green-400 cursor-pointer' onClick={() => handleRecordShare(record._id)}>
                                <FontAwesomeIcon icon={faShare} />
                              </span>
                            </Tooltip>
                            <Tooltip text={"Save"} position={"top"}>
                              <span className='text-blue-400 cursor-pointer' onClick={() => handleRecordSave(record._id)}>
                                <FontAwesomeIcon icon={faSave} />
                              </span>
                            </Tooltip>
                            <Tooltip text={"Print"} position={"top"}>
                              <span className='text-orange-400 cursor-pointer' onClick={() => handleRecordPrint(record._id)}>
                                <FontAwesomeIcon icon={faPrint} />
                              </span>
                            </Tooltip>
                          </div> */}
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>   
    </div>
  );
};

export default Think5WhysDB;
